module.exports = __webpack_public_path__ + "static/img/logoimg.2d44c223.png";